import Marquee from "react-fast-marquee";

const items = [
  "NAPIT Approved",
  "Gas Safe Registered",
  "Fully Insured",
  "Free Quotations",
  "Domestic & Commercial",
  "Ford Transit Fleet",
  "Local & Trusted",
];

export const BrandMarquee = () => {
  return (
    <section className="bg-ink py-5 border-y border-white/10" data-testid="brand-marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-lg md:text-xl font-medium text-white/85 mx-8">
              {t}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-brand-yellow" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
